import styled from 'styled-components';

export const SheetBackdrop = styled.div<{ isClosing: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(18, 18, 18, 0.2);
  z-index: 9998;
  opacity: ${({ isClosing }) => (isClosing ? 0 : 1)};
  transition: opacity 0.3s ease;
`;

export const SheetContainer = styled.div<{ maxHeight: string }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--allie-color-white, white);
  border-top-left-radius: var(--allie-radius-xl, 20px);
  border-top-right-radius: var(--allie-radius-xl, 20px);
  box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  max-height: ${({ maxHeight }) => maxHeight};
  transform: translateY(100%);
  will-change: transform;
  touch-action: none;
`;

export const SheetHandle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--allie-spacing-md, 12px) 0;
  cursor: grab;
  touch-action: none;

  &:active {
    cursor: grabbing;
  }
`;

export const SheetHandleBar = styled.div`
  width: 40px;
  height: 4px;
  background-color: var(--allie-color-neutral-40, #ccc);
  border-radius: 2px;
`;

export const SheetContent = styled.div`
  overflow-y: auto;
  max-height: calc(100% - 28px);
  -webkit-overflow-scrolling: touch;
`;
